import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "./router";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import useReveal from "./hooks/useReveal";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import InvestorsPage from "./pages/InvestorsPage";
import SellPage from "./pages/SellPage";
import BuyPage from "./pages/BuyPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

export default function App() {
  useReveal();
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/properties" element={<PropertiesPage />} />
          <Route path="/properties/:id" element={<PropertyDetailPage />} />
          <Route path="/investors" element={<InvestorsPage />} />
          <Route path="/sell" element={<SellPage />} />
          <Route path="/buy" element={<BuyPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
